/**
 * Application Constants
 * Centralized constants for pagination, API, and network settings
 */

// ========================================
// Pagination Constants
// ========================================
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
  COMMUNITY_LIST_LIMIT: 10,
  MEMBER_LIST_LIMIT: 50,
  INFINITE_SCROLL_LIMIT: 50,
}

// ========================================
// API & Network Constants
// ========================================
export const API = {
  DEBOUNCE_DELAY_MS: 500,
  INFINITE_SCROLL_THRESHOLD_PX: 200,
  SOCKET_MAX_RECONNECT_ATTEMPTS: 5,
  SOCKET_RECONNECTION_DELAY_MS: 1000,
}
